{
  "CapabilitiesAffected": "影響を受ける機能：",
  "ShowRelated": "関連する {relatedCount} 個を表示"
}
